export const KpisDetailsRowsPerPage = 12;
